import { entry_preview_exports } from './chunk-CQ7IB4U6.mjs';
import { entry_preview_argtypes_exports } from './chunk-N3U7HZRZ.mjs';
import { entry_preview_docs_exports } from './chunk-AWLHXXSE.mjs';
import { definePreview } from 'storybook/internal/csf';

function __definePreview(input){let preview=definePreview({...input,addons:[entry_preview_exports,entry_preview_argtypes_exports,entry_preview_docs_exports,...input.addons??[]]}),defineMeta=preview.meta.bind(preview);return preview.meta=_input=>{let meta=defineMeta(_input),defineStory=meta.story.bind(meta);return meta.story=__input=>{let story=defineStory(__input);return story.Component=story.__compose(),story},meta},preview}

export { __definePreview };
